import React from "react";
import { Card } from "@/components/ui/card";

const FoodCategories = ({
  categories,
  onSelectSubcategory,
  selectedSubcategory,
}) => {
  console.log("[FoodCategories] Render with:", {
    categories,
    selectedSubcategory,
  });

  if (!categories || categories.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">
        No hay categorías disponibles
      </div>
    );
  }

  const handleCategoryClick = (category) => {
    console.log("Clicked category:", category); // Debug log

    if (!category || !category._id) {
      console.warn("Invalid category selected:", category);
      return;
    }

    onSelectSubcategory(category._id);
  };

  return (
    <div className="overflow-x-auto pb-4 hide-scrollbar">
      <div className="flex gap-4 px-4 min-w-max">
        {categories.map((category) => {
          console.log("Rendering category:", category); // Debug log

          return (
            <div key={category._id} className="w-32">
              <Card
                className={`h-32 flex flex-col items-center justify-center p-4 cursor-pointer transition-colors ${
                  selectedSubcategory === category._id
                    ? "bg-orange-500 text-white"
                    : "bg-white hover:bg-orange-50"
                }`}
                onClick={() => handleCategoryClick(category)}
              >
                <div
                  className={
                    selectedSubcategory === category._id
                      ? "text-white"
                      : "text-orange-500"
                  }
                >
                  {category.icon || (
                    <svg
                      viewBox="0 0 24 24"
                      className="w-8 h-8"
                      fill="currentColor"
                    >
                      <path d="M13.37 2.094C10.77 2.094 8.674 3.624 8.674 5.5c0 1.876 2.096 3.406 4.696 3.406s4.696-1.53 4.696-3.406c0-1.876-2.096-3.406-4.696-3.406z" />
                    </svg>
                  )}
                </div>
                <span className="text-sm font-medium text-center mt-2 whitespace-pre-line">
                  {category.name}
                </span>
              </Card>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FoodCategories;
